import React, { useEffect } from "react";
import { sizeUnits } from "_constants";
import { Field } from "formik";
import FormContainer from "forms/components/FormContainer";
import FormRow from "forms/components/FormRow";
import { DateField, DropdownField, RangeField, RenderField } from "forms/fields";
import PropTypes from "prop-types";

import { Translate } from "utils";
import dealName from "utils/deals/name";
import { isRequired } from "utils/validation";

import { getDefaultStage } from "..";

const { t } = new Translate("DealForm");

const Details = ({ formik: { setFieldValue, values }, isCompanyPage, portfolios }) => {
  const dealStages = Object.values((values.portfolio || {}).dealStages || {});

  useEffect(() => {
    const stage = getDefaultStage(values.portfolio);

    if (stage !== values.stage) {
      setFieldValue("stage", stage);
    }
    // Explicitly remove values.stage from here to prevent it being reset to the portfolio default
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.portfolio, setFieldValue]);

  return (
    <FormContainer title={t("details.title")}>
      <FormRow>
        <Field
          component={RenderField}
          label={t("name")}
          name="name"
          placeholder={dealName(values)}
        />
        <Field
          component={DropdownField}
          label={t("stage")}
          name="stage"
          values={dealStages}
          valueExtractor={(dealStage) => t(`dealStages.${dealStage}`)}
          isDisabled={dealStages.length === 0}
        />
      </FormRow>
      <FormRow>
        <Field
          component={RangeField}
          label={t("size.title")}
          name="size"
          separator={t("to")}
          units={sizeUnits}
        />
        <Field component={DateField} label={t("startDate")} name="startDate" isInput />
      </FormRow>
      {isCompanyPage && (
        <FormRow>
          <Field
            component={DropdownField}
            label={t("portfolio")}
            name="portfolio"
            placeholder={t("placeholders.portfolios")}
            validate={isRequired}
            valueExtractor={(p) => p.name}
            values={portfolios}
          />
        </FormRow>
      )}
    </FormContainer>
  );
};

Details.propTypes = {
  formik: PropTypes.shape({
    values: PropTypes.object,
  }),
  isCompanyPage: PropTypes.bool,
  portfolios: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
};

export default Details;
